import { Auth } from 'aws-amplify'

import * as types from './action-types'
import * as transcriptionsActions from '../transcriptions/actions'

export const load = () => dispatch =>
  Auth.currentSession()
    .then(currentSession => {
      if (currentSession) {
        dispatch(authenticationSuccess())
      }
    })
    .catch(e => console.warn(e))
    .then(() => dispatch({ type: types.LOADED }))
    .then(() => dispatch(transcriptionsActions.load()))

export const login = ({ email, password }) => dispatch => {
  dispatch(authenticationRequest())

  Auth.signIn(email, password)
    .then(() => dispatch(authenticationSuccess()))
    .catch(e => dispatch(authenticationFailure(e.message)))
    .then(() => dispatch(transcriptionsActions.load()))
}

export const logout = () => dispatch => {
  dispatch({ type: types.LOGOUT })
  Auth.signOut()
}

export const authenticationRequest = () => ({
  type: types.AUTHENTICATION_REQUEST
})

export const authenticationSuccess = () => ({
  type: types.AUTHENTICATION_SUCCESS
})

export const authenticationFailure = error => ({
  type: types.AUTHENTICATION_FAILURE,
  payload: { error }
})



// WEBPACK FOOTER //
// ./src/redux/user/actions.js